<template>
    <div class="x-tag">
        <el-tag :closable="config.closable" class="ml-2" v-for="(option) in getTagDatas(dataOptions, modelValue)" :key="option.value"
            @close="closeHandler(option.value)"
        >
            {{getLabel(option.label)}}
        </el-tag>
    </div>
</template>
<script setup>
import { ref, watch, getCurrentInstance } from "vue";
import DataOptions from "../../dataview/DataOptions";

const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
});
defineEmits({
    'update:modelValue': null,
    'close': null,
})

let div = null;

const getLabel = (content)=> {
    if (!div) div = document.createElement('div');
    div.innerHTML = content;
    return div.innerText;
}

const dataOptions = ref(null);
watch(()=> props.config?.dataOptions, (value)=> {
    dataOptions.value = value ? new DataOptions(value) : null;
}, {immediate:true, deep:true})

const getTagDatas = (dataOptions, modelValue)=> {
    return dataOptions ? dataOptions.getOptionsTags(modelValue) : modelValue;
};

const closeHandler = (value)=> {
    // console.log('close click', value);
    const values = [...props.modelValue];
    values.splice(values.indexOf(value), 1);
    inst.emit('update:modelValue', values);
    inst.emit('close', value);
    // {modelValue.splice(modelValue.indexOf(option.value), 1); $emit('update:modelValue', modelValue)}
}
</script>
<style scoped>
    .x-tag>>>.el-tag {
        margin: 2px;
    }
</style>